
export class ColumnMap {
    sourceColumnName = '';
    dataType = '';
    targetColumnName = '';
    pyDataType = '';

    constructor(sourceColumn: string, targetColumn: string, dateType: string, pyDataType: string) {
        this.sourceColumnName = sourceColumn;
        this.targetColumnName = targetColumn;
        this.dataType = dateType;
        this.pyDataType = pyDataType;
    }
}
